import { render } from "./CompletePurchaseModal.vue?vue&type=template&id=4915a4d4"
import script from "./CompletePurchaseModal.vue?vue&type=script&lang=js"
export * from "./CompletePurchaseModal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__